import { API_V2 } from './apiVersion';

export const AUTH_ENDPOINTS = {
  SIGNUP: `${API_V2}/auth/signup`,
  LOGIN: `${API_V2}/auth/login`,
  LOGOUT: `${API_V2}/auth/logout`,
  REFRESH: `${API_V2}/auth/refresh`,

  CHECK_ID: `${API_V2}/auth/check-id`,
  CHECK_NICKNAME: `${API_V2}/auth/check-nickname`,
  CHECK_PHONE: `${API_V2}/auth/check-phone`,

  FIND_ID: `${API_V2}/auth/find-id`,
  RESET_PASSWORD: `${API_V2}/auth/password/reset`,

  PHONE: {
    SEND: `${API_V2}/auth/phone/send`,
    VERIFY: `${API_V2}/auth/phone/verify`,
  },
} as const;
